/* 07/10/2026 (multidioma fase 2): «Guía de tallas» desde window.N1T; los acordeones se reconocen primero por el id del bloque (desc, comp, care, tech) y el texto queda de respaldo.
   N1 · Ficha de ropa: guía de tallas en la fila de Talla; orden de acordeones; sin duplicado de Ficha técnica.
   07/10/2026 (multidioma fase 1): la talla y los acordeones se reconocen también en inglés y portugués. */
(function(){
if(window.N1RopaSize)return;window.N1RopaSize=1;
var T=function(k,d){var v=window.N1T&&window.N1T[k];return (typeof v==='string'&&v&&!/translation missing/i.test(v))?v:d},F=function(s,o){return String(s).replace(/\{(\w+)\}/g,function(m,k){return o&&o[k]!=null?o[k]:m})};
var RX_SIZE=/talla|size|tamanho|tamaño/i,
    RX_TECH=/ficha técnica|ficha tecnica|technical|specifications|especificações/i,
    RX_DESC=/descripción|descrição|description/i,
    RX_COMP=/composición|composição|composition/i,
    RX_CARE=/cuidado de la ropa|garment care|care|cuidados|cuidado da roupa/i;
function sizeLink(){
  var a=document.querySelector('.n1-sizeropa a');
  var opts=document.querySelectorAll('.product-info .variant-picker__option');
  for(var i=0;i<opts.length;i++){
    var l=opts[i].querySelector('legend');
    if(!l||!RX_SIZE.test(l.textContent))continue;
    opts[i].classList.add('n1-talla');
    var info=opts[i].querySelector('.variant-picker__option-info')||l.parentNode;
    if(a&&!info.querySelector('.n1-sizefind')){a.className='n1-sizefind';a.innerHTML='<svg viewBox="0 0 24 24"><path d="M3 17 17 3l4 4L7 21H3z"/><path d="M6 14l2 2M9 11l2 2M12 8l2 2M15 5l2 2"/></svg>'+T('n1.pdp.size_guide','Guía de tallas');info.appendChild(a)}
    break;
  }
}
function dedupe(){
  /* solo actua si hay mas de un acordeon "Ficha tecnica": deja el que tiene contenido y quita los vacios */
  var list=[].slice.call(document.querySelectorAll('.product-info details')).filter(function(d){
    var s=d.querySelector('summary');return s&&RX_TECH.test(s.textContent);
  });
  if(list.length<2)return;
  var keep=null;
  list.forEach(function(d){
    var c=d.querySelector('.accordion__content');
    if(!keep&&c&&c.textContent.replace(/\s+/g,'').length>2)keep=d;
  });
  if(!keep)keep=list[0];
  list.forEach(function(d){
    if(d===keep)return;var h=d.closest('.product-info__block-item')||d.closest('accordion-disclosure')||d;h.remove();
  });
}
function order(){
  var all=[].slice.call(document.querySelectorAll('.product-info details'));if(!all.length)return;
  function byId(id){var b=document.querySelector('.product-info__block-item[data-block-id="'+id+'"] details');return b||null}
  function find(re){for(var i=0;i<all.length;i++){var s=all[i].querySelector('summary');if(s&&re.test(s.textContent))return all[i]}return null}
  var desc=byId('desc')||find(RX_DESC),comp=byId('comp')||find(RX_COMP),tech=byId('tech')||find(RX_TECH),care=byId('care');
  if(!care)for(var j=0;j<all.length;j++){var sm=all[j].querySelector('summary');if(sm&&RX_CARE.test(sm.textContent)&&all[j]!==desc&&all[j]!==comp&&all[j]!==tech){care=all[j];break}}
  if(!desc)return;
  function host(d){return d.closest('.product-info__block-item')||d.closest('accordion-disclosure')||d}
  var seq=[desc,comp,care,tech].filter(Boolean),parent=host(desc).parentNode,anchor=host(desc);
  for(var i=1;i<seq.length;i++){var h=host(seq[i]);if(anchor.nextSibling!==h)parent.insertBefore(h,anchor.nextSibling);anchor=h}
}
function run(){try{sizeLink()}catch(e){}try{dedupe()}catch(e){}try{order()}catch(e){}}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
addEventListener('load',run);setTimeout(run,900);setTimeout(run,1800);setTimeout(run,3200);
new MutationObserver(function(){clearTimeout(window.__n1rs);window.__n1rs=setTimeout(run,400)}).observe(document.body,{childList:true,subtree:true});
})();